import { api } from './baseApiSetup.js';
import GetProxy from '../GetProxy.js';

const proxy = GetProxy()
const OBSERVABILITY_BASE_URL = `${proxy}/api/v1`;

export const observabilityApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAppList: build.query({
      query: ({ userName,userRole }) => ({
        url: `${OBSERVABILITY_BASE_URL}/cmdb/${userName}/${userRole}`,
      }),
      transformResponse: (appList) =>
        appList?.map((app) => {
          return {
            label: `${app.appName}[${app.appCode}]`,
            value: app.appCode,
            id: app.id,
          };
        }),
    }),
    getProjectList: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/home/projectLists`,
        method: "POST",
        body: postBody,
      }),
      transformResponse: (projectList) =>
        projectList?.map((proj) => {
          return { label: proj.projectName, value: proj.projectName };
        }),
    }),
    getSprintList: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/home/sprint/sprintNames`,
        method: "POST",
        body: postBody,
      }),
      transformResponse: (sprintList) =>
        sprintList?.map((sprint) => {
          return { label: sprint, value: sprint };
        }),
    }),
    //Flow Metrics Page start
    getFlowDistribution: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/flowDistribution/main`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFlowVelocity: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/flowVelocity/main`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFlowPredictability: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/flowMetrics/ddflowpredicatablitymain`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFlowPredictabilityDrill: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/flowMetrics/ddflowpredicatablitymonth`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFlowPredictabilitySummary: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/flowMetrics/ddFlowSummary`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFlowEfficiency: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/flowEfficiency/main`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFlowEfficiencyDrill: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/flowEfficiency/main/drilldown`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFlowEfficiencyDrillSummary: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/flowEfficiency/main/summary`,
        method: "POST",
        body: postBody,
      }),
    }),
    getActiveSprints: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/flowMetrics/activeSprints`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFlowLoad: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/flowMetrics/flowLoadMain`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFlowJiraDetails: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/home/activeSprint/jiraDetails`,
        method: "POST",
        body: postBody,
      }),
    }),
    getFlowJiraSprintLists: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/home/activeSprint/jiraSprintLists`,
        method: "POST",
        body: postBody,
      }),
    }),
    getLevelOfCollaborationLists: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/peopleMetric/comments/ddtwo`,
        method: "POST",
        body: postBody,
      }),
    }),

    //People Metrics
    getIssueMetrics: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/peopleMetrics/issueMetric/main`,
        method: "POST",
        body: postBody,
      }),
    }),
    getIssueMetricsDdOne: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/issueMetrics/drillDownOne`,
        method: "POST",
        body: postBody,
      }),
    }),
    getCollaboration: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/peopleMetric/comments/main`,
        method: "POST",
        body: postBody,
      }),
    }),
    getTopAssignee: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/peopleMetric/topAssignee`,
        method: "POST",
        body: postBody,
      }),
    }),
    getCommentsDdOne: build.mutation({
      query: ({month,year,locdrilldown}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/peopleMetric/comments/ddone/${year}/${month}`,
        method: "POST",
        body: locdrilldown,
      }),
    }),

    //flowup button
    getFollowButtonData: build.mutation({
      query:({userName,payload})=>({
        url: `${OBSERVABILITY_BASE_URL}/peopleMetrics/sprint/issueMetrics/followUp/${userName}`,
        method: "POST",
        body: payload,
        }),
    }),

    //ProjectChamp
    getProjectChampData: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/projectChampions/main`,
        method: "POST",
        body: postBody,
        }),
    }),
    getTopContributorsData: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/developerQuality/main`,
        method: "POST",
        body: postBody,
        }),
    }),
    getTopContributorsDDoneData: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/developerQuality/ddone`,
        method: "POST",
        body: postBody,
        }),
    }),

    getPeopleDrilltwoData: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/peopleMetric/comments/ddtwo`,
        method: "POST",
        body: postBody,
        }),
    }),


    // getLocCommentsDdOne: build.mutation({
    //   query: (postBody = {}) => ({
    //     url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/peopleMetric/comments/ddone/2022/12`,
    //     method: "POST",
    //     body: postBody,
    //   }),
    // }),
    //productivity Metrics
    getStaticCodeAnalysis: build.mutation({
      query: (postedBy = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/productivityMetrics/staticCodeAnalysis/main`,
        method: "POST",
        body: postedBy,
      }),
    }),
    getStaticCodeAnalysisDDOne: build.mutation({
      query: (postedBy = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/productivityMetrics/staticCodeAnalysis/ddone`,
        method: "POST",
        body: postedBy,
      }),
    }),
    getStaticCodeFollowUp: build.mutation({
      query: ({FollowUpayload,assigneeName,userName}) => ({
        url: `${OBSERVABILITY_BASE_URL}/productivityMetrics/sprint/staticCode/followUp/${assigneeName}/${userName}`,
        method: "POST",
        body: FollowUpayload,
      }),
    }),
    getLinesOfCodes: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/codeAnalysisForMain/ddone`,
        method: "POST",
        body: postBody,
      }),
    }),
    getCodeQualityAnalysis: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/codeAnalysis/main`,
        method: "POST",
        body: postBody,
      }),
    }),
    getLineOfCodeDatewise: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/codeAnalysis/ddone`,
        method: "POST",
        body: postBody,
      }),
    }),
    getBuildMetrics: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/productMetric/buildMetric/ddone`,
        method: "POST",
        body: postBody,
      }),
    }),
    getJobName: build.query({
      query: ({ jobName1,jobName2 }) => ({
       url: `${OBSERVABILITY_BASE_URL}/productivityMetrics/buildMetricDrillDownUrl/${jobName1}/${jobName2}`,
       method: "GET"
      }),
    }),
    getDeploymentMetrics: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/productMetric/deployment/main`,
        method: "POST",
        body: postBody,
      }),
    }),
    getDeploymentMonthMetrics: build.mutation({
      query: ({buildDeploymentPayload,month,year}) => ({
        url: `${OBSERVABILITY_BASE_URL}/safeFlowMetrics/flow/productMetric/deployment/${year}/${month}`,
        method: "POST",
        body: buildDeploymentPayload,
      }),
    }),
    //opsMetrics
    //Incident Management
    getIncidents: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/incidentManagement/filter/noOfIncident`,
        method: "POST",
        body: postBody,
      }),
    }),
    getIncidentsPercategory: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/incidentManagement/filter/category`,
        method: "POST",
        body: postBody,
      }),
    }),
    getMeanTimetoRecover: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/incidentManagement/filter/MTTR/Dashboard`,
        method: "POST",
        body: postBody,
      }),
    }),
    getMTBI: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/incidentManagement/filter/MTBI`,
        method: "POST",
        body: postBody,
      }),
    }),
    getIncidentMTTR: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/incidentManagement/filter/incidentMTTR`,
        method: "POST",
        body: postBody,
      }),
    }),
    //ChangeManagement
    getChangeRequest: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/changeManagement/filter/noOfChangeRequest`,
        method: "POST",
        body: postBody,
      }),
    }),
    getRootCause: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/changeManagement/getByRootCause/${postBody.type}`,
        method: "POST",
        body: postBody,
      }),
    }),
    getChangeRequestPerCategory: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/changeManagement/filter/category`,
        method: "POST",
        body: postBody,
      }),
    }),
    getChangeRequestPerRisk: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/changeManagement/filter/getForRisk`,
        method: "POST",
        body: postBody,
      }),
    }),
    getMeanTimetoChange: build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/changeManagement/filter/meanTime/dashboard`,
        method: "POST",
        body: postBody,
      }),
    }),
    getMeanTimeChangeType:build.mutation({
      query: (postBody = {}) => ({
        url: `${OBSERVABILITY_BASE_URL}/changeManagement/filter/meanTime/type`,
        method: "POST",
        body: postBody,
      }),
    }),
  }),
  overrideExisting: true,
});



